// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3eXas","col":"styles_col__33xAK"};